import React from 'react';

export const MentionDropdown = ({ participants, filter, onSelect, activeIndex, currentUserId }) => {
    const filtered = (participants || [])
        .filter((p) => p.userId !== currentUserId)
        .filter((p) => {
            if (!filter) return true;
            const name = p.user ? `${p.user.firstName} ${p.user.lastName}`.toLowerCase() : '';
            return name.includes(filter.toLowerCase());
        });

    if (!filtered.length) return null;

    return (
        <div className="chat-mention-dropdown">
            {filtered.map((p, index) => {
                const name = p.user ? `${p.user.firstName} ${p.user.lastName}` : p.userId;
                const initials = p.user ? `${p.user.firstName?.[0] || ''}${p.user.lastName?.[0] || ''}`.toUpperCase() : '?';

                return (
                    <div
                        key={`${p.userId}-${p.userType}`}
                        className={`chat-mention-item ${index === activeIndex ? 'chat-mention-item-active' : ''}`}
                        onClick={() => onSelect(p)}
                    >
                        {p.user?.avatar ? (
                            <img
                                src={p.user.avatar}
                                alt={name}
                                style={{
                                    width: '24px',
                                    height: '24px',
                                    borderRadius: '50%',
                                    objectFit: 'cover',
                                }}
                            />
                        ) : (
                            <div
                                style={{
                                    width: '24px',
                                    height: '24px',
                                    borderRadius: '50%',
                                    background: '#E4E7EC',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '10px',
                                    fontWeight: '600',
                                    color: '#344054',
                                }}
                            >
                                {initials}
                            </div>
                        )}
                        {name}
                    </div>
                );
            })}
        </div>
    );
};
